import React from 'react';
import { howItWorks } from '../../data/mock';
import { ArrowRight, Check } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-teal-50/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-teal-200 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center mb-20">
          <span className="inline-block px-4 py-2 bg-teal-100 text-teal-700 text-sm font-medium rounded-full mb-6">
            Simple Process
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            How It
            <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent"> Works</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Start your health journey in three simple steps and take control of your diabetes management.
          </p>
        </div>

        {/* Steps */}
        <div className="grid lg:grid-cols-3 gap-8 lg:gap-12">
          {howItWorks.map((item, index) => (
            <div key={item.step} className="relative">
              {/* Connector line */}
              {index < howItWorks.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-px">
                  <div className="relative w-full h-full">
                    <div className="absolute inset-0 bg-gradient-to-r from-teal-300 to-cyan-300" />
                    <ArrowRight className="absolute -right-3 -top-3 w-6 h-6 text-cyan-400" />
                  </div>
                </div>
              )}

              <div className="group">
                {/* Step number */}
                <div className="relative w-32 h-32 mx-auto mb-8">
                  {/* Outer ring */}
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-100 to-cyan-100 rounded-full" />
                  {/* Inner circle */}
                  <div className="absolute inset-3 bg-white rounded-full shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <span className="text-5xl font-bold bg-gradient-to-br from-teal-600 to-cyan-600 bg-clip-text text-transparent">
                      {item.step}
                    </span>
                  </div>
                  {/* Animated ring */}
                  <div className="absolute inset-0 rounded-full border-2 border-teal-400/30 animate-ping" style={{ animationDuration: '3s' }} />
                </div>

                {/* Content card */}
                <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-sm hover:shadow-xl hover:border-teal-200 transition-all duration-500 text-center">
                  <h3 className="text-xl font-bold text-slate-800 mb-4">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {item.description}
                  </p>

                  {/* Check icon */}
                  <div className="mt-6 flex justify-center">
                    <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center shadow-lg shadow-teal-200">
                      <Check className="w-5 h-5 text-white" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
